
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#757F8A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.176 13.055a.852.852 0 00.75-.428.83.83 0 00.117-.428.89.89 0 00-.275-.638l-3.68-3.563 3.68-3.568a.851.851 0 00-.156-1.368.852.852 0 00-.436-.115.811.811 0 00-.598.24L5.377 7.296a.992.992 0 00-.243.328 1.012 1.012 0 00-.08.375c0 .133.026.256.077.37.05.112.133.224.246.333l4.201 4.113c.16.16.36.24.598.24z"}}),_c('path',{attrs:{"d":"M16.176 13.055a.852.852 0 00.75-.428.83.83 0 00.117-.428.89.89 0 00-.275-.638l-3.68-3.563 3.68-3.568a.851.851 0 00-.156-1.368.852.852 0 00-.436-.115.811.811 0 00-.598.24l-4.201 4.108a.992.992 0 00-.243.328 1.012 1.012 0 00-.08.375c0 .133.026.256.077.37.05.112.133.224.246.333l4.201 4.113c.16.16.36.24.598.24z"}})])])
          )
        }
      }
    